module.exports = "https://deal-img.imgix.net/consumer/modern/notification-denied@2x.2664a42e.png";